import { Action, createAction, createReducer, on, props } from '@ngrx/store';
import merge from 'lodash/merge';

interface LayoutSetting {
  menuCollapsed: boolean;
  title: string;
  hideContentTitle: boolean;
  passportWidth: string | number;
  fullCurrency: boolean;
  deadlineDay: number;
  roles: string[];
  noPermission: boolean;
  needBigGroup: boolean;
  videoTutorial: boolean;
  asyncExport: boolean;
}

export const setPassportWidth = createAction('[Passport] Set Route Area Width', props<{ width: string | number }>());
export const setMenuCollapsed = createAction('[Sidebar] Menu Change Collapsed', props<{ collapsed: boolean }>());
export const setVideoTutorial = createAction('[Tutorial] Video Tutorial', props<{ videoTutorial: boolean }>());
export const setAsyncExport = createAction('[Export] Async Export', props<{ asyncExport: boolean }>());
export const setDeadlineDay = createAction('[Enterprise] Set DeadlineDay', props<{ deadlineDay: number }>());
export const setRole = createAction('[User] Set Role', props<{ roles: string[] }>());
export const setTitle = createAction(
  '[Content] Content Set Title',
  props<{ title: string; hideContentTitle: boolean; fullCurrency: boolean }>()
);
export const setNoPermission = createAction('[Sidebar] noPermission Change', props<{ noPermission: boolean }>());
export const setNeedBigGroup = createAction('[Sidebar] needBigGroup Change', props<{ needBigGroup: boolean }>());
export const setEmptyMenu = createAction('[Sidebar] emptyMenu Change', props<{ emptyMenu: boolean }>());

export function layoutReducer(storeState: LayoutSetting | undefined, action: Action) {
  return createReducer(
    {},

    on(setVideoTutorial, (state, { videoTutorial }) => merge({}, state, { videoTutorial: videoTutorial })),
    on(setAsyncExport, (state, { asyncExport }) => merge({}, state, { asyncExport: asyncExport })),
    on(setMenuCollapsed, (state, { collapsed }) => merge({}, state, { menuCollapsed: collapsed })),
    on(setDeadlineDay, (state, deadlineDay) => merge({}, state, deadlineDay)),
    on(setRole, (state, roles) => merge({}, state, roles)),
    on(setPassportWidth, (state, { width }) => merge({}, state, { passportWidth: width })),
    on(setTitle, (state, title) => merge({}, state, title)),
    on(setNoPermission, (state, { noPermission }) => merge({}, state, { noPermission: noPermission })),
    on(setNeedBigGroup, (state, { needBigGroup }) => merge({}, state, { needBigGroup: needBigGroup })),
    on(setEmptyMenu, (state, { emptyMenu }) => merge({}, state, { emptyMenu: emptyMenu }))
  )(storeState, action);
}
